import categories from "./categories";
import orders from "./orders";
import products from "./products";
import purchases from "./purchases";

export default {
    categories,
    orders,
    products,
    purchases
}
